import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ContentBlock } from '../../models';
import { ImageComponent } from '@teamfoster/sdk/image';
import { RouterLink } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-content-block-featured-collection',
  templateUrl: './content-block-featured-collection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, RouterLink, FromDictionaryPipe, NgOptimizedImage],
})
export class ContentBlockFeaturedCollectionComponent {
  @Input() block!: ContentBlock;

  constructor() {}
}
